import React from "react";

export const InfoIconSvg = ({
  width = 225,
  height = 179,
  style = {},
  strokeColor = "#000000", // Default fill color from original SVG
}) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 225 179"
    preserveAspectRatio="xMidYMid meet"
    width={width}
    height={height}
    style={style}
  >
    <g
      transform="translate(0.000000,179.000000) scale(0.100000,-0.100000)"
      fill={strokeColor}
      stroke="none"
    >
      <path
        d="M964 1705 c-97 -17 -136 -31 -225 -76 -268 -139 -431 -406 -431 -709
        0 -246 106 -468 297 -622 345 -278 859 -218 1127 133 118 154 163 289 163 489
        0 153 -14 218 -71 340 -154 326 -508 509 -860 445z m351 -119 c112 -36 197
        -89 285 -176 133 -132 200 -296 200 -490 0 -194 -67 -358 -200 -490 -221 -220
        -529 -270 -810 -133 -79 39 -109 61 -181 132 -140 140 -203 293 -203 491 0
        126 18 202 76 320 33 68 59 102 127 171 72 71 102 93 181 132 123 60 205 78
        340 73 77 -3 126 -11 185 -30z"
      />
      <path
        d="M1050 1268 c-43 -46 -10 -118 54 -118 41 0 69 29 69 70 0 64 -79 95
        -123 48z"
      />
      <path
        d="M946 1004 c-39 -39 -7 -84 60 -84 l44 0 0 -150 0 -150 -60 0 c-52 0
        -61 -3 -76 -25 -15 -23 -15 -27 0 -50 16 -25 16 -25 182 -25 95 0 174 4 185
        10 12 7 19 21 19 40 0 38 -23 50 -94 50 l-56 0 0 190 c0 221 6 210 -114 210
        -54 0 -79 -4 -90 -16z"
      />
    </g>
  </svg>
);

export const RestaurantIconSvg = ({
  width = 217,
  height = 182,
  style = {},
  strokeColor = "#000000", // default fill color from original SVG
}) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 217 182"
    preserveAspectRatio="xMidYMid meet"
    width={width}
    height={height}
    style={style}
  >
    <g
      transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
      fill={strokeColor}
      stroke="none"
    >
      <path
        d="M396 1714 c-9 -8 -16 -17 -16 -19 0 -3 -18 -114 -40 -247 -40 -242
        -43 -291 -18 -358 32 -87 117 -148 219 -157 l59 -6 0 -377 c0 -356 1 -379 19
        -401 16 -20 23 -22 47 -14 l29 10 3 391 2 391 65 6 c143 14 234 110 235 252 1
        90 -70 503 -90 528 -22 26 -67 17 -75 -16 -3 -12 10 -118 29 -234 43 -253 45
        -316 13 -364 -39 -58 -74 -69 -226 -69 -148 0 -191 13 -224 69 -31 53 -30 98
        12 346 37 217 39 242 25 262 -17 27 -46 30 -68 7z"
      />
      <path
        d="M547 1712 c-14 -15 -19 -63 -30 -273 -7 -140 -10 -264 -6 -276 14
        -38 70 -41 84 -5 4 9 13 132 20 272 12 222 12 258 -1 278 -18 27 -45 28 -67 4z"
      />
      <path
        d="M696 1711 c-16 -18 -17 -37 -5 -282 11 -230 15 -265 31 -281 22 -22
        42 -23 62 -2 19 19 19 27 5 314 -12 234 -19 270 -58 270 -10 0 -26 -9 -35 -19z"
      />
      <path
        d="M1494 1691 c-56 -28 -97 -58 -135 -98 -123 -129 -149 -215 -156 -523
        -7 -267 1 -313 60 -375 53 -54 91 -65 230 -65 l107 0 0 -229 c0 -210 2 -231
        19 -252 16 -20 23 -22 47 -14 l29 10 3 762 2 762 -22 26 c-39 45 -89 44 -184
        -4z m106 -511 l0 -450 -110 0 c-78 0 -119 4 -139 15 -50 25 -54 52 -49 312 4
        202 8 247 25 299 24 74 82 163 128 198 27 21 130 75 143 76 1 0 2 -202 2 -450z"
      />
    </g>
  </svg>
);

export const TableIconSvg = ({
  width = 19.09,
  height = 29.85,
  style = {},
  strokeColor = "#5ace8c", // Default stroke color set to #f5bf42, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.09 29.85"
    width={width} // Default width from original SVG, can be overridden via props
    height={height} // Default height from original SVG, can be overridden via props
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <rect
      className="cls-1"
      x=".75"
      y="6.78"
      width="17.59"
      height="16.28"
      rx="1.3"
      ry="1.3"
      style={{ stroke: strokeColor }}
    />
    <path
      className="cls-1"
      d="M5.02,5.41C5.02,2.84,7.11.75,9.68.75s4.66,2.09,4.66,4.66"
      style={{ stroke: strokeColor }}
    />
    <path
      className="cls-1"
      d="M14.07,24.43c0,2.57-2.09,4.66-4.66,4.66s-4.66-2.09-4.66-4.66"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const ReservationSvgIcon = ({
  width = 23.68, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23.68 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <rect
      className="cls-1"
      x=".75"
      y=".75"
      width="22.18"
      height="28.35"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <line
      className="cls-1"
      x1="6.91"
      y1="8.76"
      x2="16.77"
      y2="8.76"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <line
      className="cls-1"
      x1="6.91"
      y1="14.92"
      x2="16.77"
      y2="14.92"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <line
      className="cls-1"
      x1="6.91"
      y1="21.09"
      x2="16.77"
      y2="21.09"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const ClockSvgIcon = ({
  width = 29.85, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <circle
      className="cls-1"
      cx="14.92"
      cy="14.92"
      r="14.17"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <polyline
      className="cls-1"
      points="14.92 5.06 14.92 14.92 19.85 19.85"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const ZoneSvgIcon = ({
  width = 29.85, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <line
      className="cls-1"
      x1="4.51"
      y1=".75"
      x2="4.51"
      y2="25.25"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1=".75"
      y1="4.51"
      x2="25.25"
      y2="4.51"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="25.34"
      y1="4.59"
      x2="25.34"
      y2="29.1"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="4.59"
      y1="25.34"
      x2="29.1"
      y2="25.34"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const UserSvgIcon = ({
  width = 29.85, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <circle
      className="cls-1"
      cx="14.92"
      cy="6.91"
      r="6.16"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <path
      className="cls-1"
      d="M29.1,29.1H.75c0-6.81,5.52-12.32,12.32-12.32h3.7c6.81,0,12.32,5.52,12.32,12.32h0Z"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const BellSvgIcon = ({
  width = 27.38, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27.38 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M24.48,15.07c0,4.1,2.15,9.1,2.15,9.1H.75s2.12-5,2.12-9.1C2.87,7.17,6.98.75,13.69.75s10.79,6.42,10.79,14.32Z"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <circle
      className="cls-1"
      cx="13.69"
      cy="27.25"
      r="1.85"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const OnOffSvgIcon = ({
  width = 29.91, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.91 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M21.41,2.25c4.6,2.34,7.75,7.12,7.75,12.64,0,7.85-6.35,14.2-14.2,14.2S.75,22.74.75,14.89C.75,9.36,3.9,4.59,8.5,2.25"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <line
      className="cls-1"
      x1="14.95"
      y1=".75"
      x2="14.95"
      y2="15.51"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const BubbleTextSvgIcon = ({
  width = 51.45, // Default width from original SVG
  height = 30.54, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 51.45 30.54"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M47.6,23.83l2.37,5.27-5.89-2.53c-2.71,1.56-6.05,2.53-9.76,2.53-1.96,0-3.73-.19-5.49-.78,6.27-2.53,10.57-7.61,10.57-13.47,0-4.3-2.15-8.01-5.49-10.76h.41c8.98,0,16.23,5.68,16.23,12.51,0,2.74-.98,5.08-2.95,7.23h0ZM37.05,14.66h0c0-3.74-1.95-7.26-5.1-9.6-3.31-2.75-7.83-4.3-12.91-4.3C9.06.75.84,7.02.84,14.66c0,2.9,1.17,5.83,3.13,7.98l-2.56,6.08,6.67-2.93c3.12,1.93,6.83,2.93,10.95,2.93,2.93,0,5.86-.59,8.42-1.56,5.67-2.37,9.59-7.05,9.59-12.51h0Z"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const TableSvgIcon = ({
  width = 19.09, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.09 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <rect
      className="cls-1"
      x=".75"
      y="6.78"
      width="17.59"
      height="16.28"
      rx="1.3"
      ry="1.3"
      style={{ stroke: strokeColor }}
    />
    <path
      className="cls-1"
      d="M5.02,5.41C5.02,2.84,7.11.75,9.68.75s4.66,2.09,4.66,4.66"
      style={{ stroke: strokeColor }}
    />
    <path
      className="cls-1"
      d="M14.07,24.43c0,2.57-2.09,4.66-4.66,4.66s-4.66-2.09-4.66-4.66"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const UsersSvgIcon = ({
  width = 29.85, // Default width
  height = 50, // Default height
  style = {},
  strokeColor = "#433034", // Default stroke color
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48.24 29.85" // Matches the original dimensions
    width={width} // Dynamically sets the width
    height={height} // Dynamically sets the height
    style={style} // Allows inline styling overrides
    preserveAspectRatio="xMidYMid meet" // Maintains aspect ratio
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <circle
      className="cls-1"
      cx="24.16"
      cy="8.66"
      r="5.68"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <circle
      className="cls-1"
      cx="10.73"
      cy="5.09"
      r="4.34"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <circle
      className="cls-1"
      cx="37.51"
      cy="5.09"
      r="4.34"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <path
      className="cls-1"
      d="M33.46,20.71h14.03c0-4.79-3.89-8.68-8.68-8.68h-2.6c-3.82,0-7.04,2.49-8.19,5.93-.7-.13-1.42-.22-2.16-.22h-3.41c-.77,0-1.51.08-2.23.23-1.15-3.44-4.36-5.94-8.19-5.94h-2.6C4.63,12.03.75,15.92.75,20.71h14.11c-2.29,2.08-3.76,5.05-3.76,8.39h26.12c0-3.34-1.47-6.31-3.76-8.39Z"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <path
      className="cls-1"
      d="M37.22,29.1H11.1c0-6.27,5.08-11.36,11.36-11.36h3.41c6.27,0,11.36,5.08,11.36,11.36h0Z"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const PlusSvgIcon = ({
  width = 28.35, // Default width from original SVG
  height = 28.35, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.35 28.35"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <line
      className="cls-1"
      y1="14.17"
      x2="28.35"
      y2="14.17"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="14.17"
      y1="28.35"
      x2="14.17"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const PhoneSvgIcon = ({
  width = 29.85, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 30"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M28.93,24.44l-1.33,2.53c-.25.48-.62.89-1.08,1.19-3.92,2.55-11.74-.23-18.17-6.66C1.92,15.06-.86,7.25,1.69,3.32c.3-.46.71-.83,1.19-1.08l2.53-1.33c.6-.31,1.34-.17,1.77.35l3.93,4.75c.47.57.43,1.4-.09,1.92l-1.52,1.52c-.3.3-.38.76-.2,1.15.49,1.05,1.7,3.23,4.2,5.73,2.5,2.5,4.68,3.71,5.73,4.2.39.18.85.1,1.15-.2l1.52-1.52c.52-.52,1.36-.56,1.92-.09l4.75,3.93c.52.43.67,1.17.35,1.77Z"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const NoPhoneSvgIcon = ({
  width = 29.85, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 30"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M28.93,24.44l-1.33,2.53c-.25.48-.62.89-1.08,1.19-3.92,2.55-11.74-.23-18.17-6.66C1.92,15.06-.86,7.25,1.69,3.32c.3-.46.71-.83,1.19-1.08l2.53-1.33c.6-.31,1.34-.17,1.77.35l3.93,4.75c.47.57.43,1.4-.09,1.92l-1.52,1.52c-.3.3-.38.76-.2,1.15.49,1.05,1.7,3.23,4.2,5.73,2.5,2.5,4.68,3.71,5.73,4.2.39.18.85.1,1.15-.2l1.52-1.52c.52-.52,1.36-.56,1.92-.09l4.75,3.93c.52.43.67,1.17.35,1.77Z"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="1.21"
      y1="28.58"
      x2="26.89"
      y2="2.91"
      style={{ stroke: strokeColor }}
    />
  </svg>
);
export const NoPhoneTwoLinesSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "#FAF6E9",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 30"
    width={width}
    height={height}
    style={{ cursor: "pointer", ...style }} // <-- Adicionado aqui
  >
    <style>
      {`.cls-1 {
          fill: none;
          stroke: ${strokeColor};
          stroke-width: 1.5px;
          stroke-linecap: round;
          stroke-linejoin: round;
        }`}
    </style>

    <path
      className="cls-1"
      d="M28.93,24.44l-1.33,2.53c-.25.48-.62.89-1.08,1.19-3.92,2.55-11.74-.23-18.17-6.66C1.92,15.06-.86,7.25,1.69,3.32c.3-.46.71-.83,1.19-1.08l2.53-1.33c.6-.31,1.34-.17,1.77.35l3.93,4.75c.47.57.43,1.4-.09,1.92l-1.52,1.52c-.3.3-.38.76-.2,1.15.49,1.05,1.7,3.23,4.2,5.73,2.5,2.5,4.68,3.71,5.73,4.2.39.18.85.1,1.15-.2l1.52-1.52c.52-.52,1.36-.56,1.92-.09l4.75,3.93c.52.43.67,1.17.35,1.77Z"
    />
    <line className="cls-1" x1="18" y1="4" x2="26" y2="12" />
    <line className="cls-1" x1="26" y1="4" x2="18" y2="12" />
  </svg>
);

export const EmailSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "#433034",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 30"
    width={width}
    height={height}
    style={style}
  >
    <style>
      {`.cls-1 {
        fill: none;
        stroke: ${strokeColor};
        stroke-width: 1.5px;
        stroke-linecap: round;
        stroke-linejoin: round;
      }`}
    </style>

    {/* Envelope outer */}
    <rect className="cls-1" x="4" y="7" width="22" height="16" rx="2.2" />

    {/* Envelope flap */}
    <path className="cls-1" d="M5.5 8.7 L15 16 L24.5 8.7" />
    <path className="cls-1" d="M5.5 21.7 L12.6 15.6" />
    <path className="cls-1" d="M24.5 21.7 L17.4 15.6" />
  </svg>
);

/**
 * NoEmailSvgIcon (email not confirmed / blocked)
 * - Adds a single diagonal slash, like your NoPhoneSvgIcon
 */
export const NoEmailSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "#433034",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 30"
    width={width}
    height={height}
    style={style}
  >
    <style>
      {`.cls-1 {
        fill: none;
        stroke: ${strokeColor};
        stroke-width: 1.5px;
        stroke-linecap: round;
        stroke-linejoin: round;
      }`}
    </style>

    {/* Envelope */}
    <rect className="cls-1" x="4" y="7" width="22" height="16" rx="2.2" />
    <path className="cls-1" d="M5.5 8.7 L15 16 L24.5 8.7" />
    <path className="cls-1" d="M5.5 21.7 L12.6 15.6" />
    <path className="cls-1" d="M24.5 21.7 L17.4 15.6" />

    {/* Small X (top-right) */}
    <line className="cls-1" x1="28.5" y1="4.5" x2="34.5" y2="10.5" />
    <line className="cls-1" x1="34.5" y1="4.5" x2="28.5" y2="10.5" />
  </svg>
);

/**
 * NoEmailTwoLinesSvgIcon (no email / missing email)
 * - Same idea as your NoPhoneTwoLinesSvgIcon: little "X" mark in corner
 * - Default strokeColor matches your light icon default
 */
export const NoEmailTwoLinesSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "#FAF6E9",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={width}
    height={height}
    style={{ cursor: "pointer", ...style }}
  >
    <style>
      {`.cls-1 {
        fill: none;
        stroke: ${strokeColor};
        stroke-width: 1.5px;
        stroke-linecap: round;
        stroke-linejoin: round;
      }`}
    </style>

    {/* Envelope */}
    <rect className="cls-1" x="4" y="7" width="22" height="16" rx="2.2" />
    <path className="cls-1" d="M5.5 8.7 L15 16 L24.5 8.7" />
    <path className="cls-1" d="M5.5 21.7 L12.6 15.6" />
    <path className="cls-1" d="M24.5 21.7 L17.4 15.6" />

    {/* Corner X (two lines) */}
    <line className="cls-1" x1="18" y1="4" x2="26" y2="12" />
    <line className="cls-1" x1="26" y1="4" x2="18" y2="12" />
  </svg>
);

export const FilterSvgIcon = ({
  width = 31.01, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31.01 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <polygon
      className="cls-1"
      points="30.26 5.63 18.09 20 18.09 29.1 13.11 27.63 13.11 20 .75 5.63 .75 .75 15.76 .75 30.26 .75 30.26 5.63"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const CalendarSvgIcon = ({
  width = 29.72, // Default width from original SVG
  height = 30.1, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
  fillColor = "#433034", // Default fill color for the calendar header
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.72 30.1"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`
          .cls-1 {
            stroke-width: 2px;
          }
          .cls-1, .cls-2 {
            fill: none;
            stroke-linecap: round;
            stroke-linejoin: round;
          }
          .cls-2 {
            stroke-width: 1.5px;
          }
          .cls-3 {
            fill: ${strokeColor};
            stroke-width: 0px;
          }
        `}
      </style>
    </defs>
    <rect
      className="cls-2"
      x=".81"
      y="11.53"
      width="28.1"
      height="17.82"
      style={{ stroke: strokeColor }}
    />
    <rect
      className="cls-3"
      y="2.92"
      width="29.72"
      height="6.46"
      rx=".93"
      ry=".93"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="26.27"
      y1="1"
      x2="26.27"
      y2="6.67"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="3.85"
      y1="1"
      x2="3.85"
      y2="6.67"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const XSvgIcon = ({
  width = 29.41, // Default width from original SVG
  height = 29.41, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.41 29.41"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-miterlimit: 10;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <line
      className="cls-1"
      x1=".53"
      y1=".53"
      x2="28.88"
      y2="28.88"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1=".53"
      y1="28.88"
      x2="28.88"
      y2=".53"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const GearSvgIcon = ({
  width = 29.85, // Default width from original SVG
  height = 29.85, // Default height from original SVG
  style = {},
  strokeColor = "#433034", // Default stroke color, can be overridden via props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    <circle
      className="cls-1"
      cx="14.92"
      cy="14.92"
      r="6.16"
      style={{ stroke: strokeColor, fill: "none" }}
    />
    <path
      className="cls-1"
      d="M5.06,20.47l-2.46,2.46,4.31,4.31,2.46-2.46c.86.49,1.49.97,2.46,1.23v3.08h6.16v-3.08c.97-.26,1.61-.74,2.46-1.23l2.46,2.46,4.31-4.31-2.46-2.46c.49-.86.97-1.49,1.23-2.46h3.08v-6.16h-3.08c-.26-.97-.74-1.61-1.23-2.46l2.46-2.46-4.31-4.31-2.46,2.46c-.86-.49-1.49-.97-2.46-1.23V.75h-6.16v3.08c-.97.26-1.61.74-2.46,1.23l-2.46-2.46L2.6,6.91l2.46,2.46c-.49.86-.97,1.49-1.23,2.46H.75v6.16h3.08c.26.97.74,1.61,1.23,2.46Z"
      style={{ stroke: strokeColor, fill: "none" }}
    />
  </svg>
);

export const PennotebookSvgIcon = ({
  width = 29.85, // Default width
  height = 29.85, // Default height
  style = {},
  strokeColor = "#433034", // Default stroke color
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    {/* Notebook */}
    <rect
      className="cls-1"
      x="6"
      y="4"
      width="17.85"
      height="21.85"
      rx="2"
      ry="2"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="10"
      y1="7"
      x2="19.85"
      y2="7"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="10"
      y1="10.5"
      x2="19.85"
      y2="10.5"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="10"
      y1="14"
      x2="19.85"
      y2="14"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="10"
      y1="17.5"
      x2="19.85"
      y2="17.5"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="10"
      y1="21"
      x2="19.85"
      y2="21"
      style={{ stroke: strokeColor }}
    />
    {/* Pen */}
    <path
      className="cls-1"
      d="M21.5,22.5l3.5-3.5c.39-.39.39-1.02,0-1.41l-2.1-2.1c-.39-.39-1.02-.39-1.41,0l-3.5,3.5"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="19"
      y1="23"
      x2="21.5"
      y2="22.5"
      style={{ stroke: strokeColor }}
    />
    <line
      className="cls-1"
      x1="23"
      y1="20"
      x2="24.5"
      y2="18.5"
      style={{ stroke: strokeColor }}
    />
  </svg>
);

export const ExtrasSvgIcon = ({
  width = 29.85, // Default width
  height = 29.85, // Default height
  style = {},
  strokeColor = "#433034", // Default stroke color
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    {/* Outer Starburst Shape */}
    <path
      className="cls-1"
      style={{ stroke: strokeColor }}
      d="M14.92,2.25l2.5,5.7h6.4l-4.6,4,2.3,6.3-5.6-2.8-5.6,2.8,2.3-6.3-4.6-4h6.4l2.5-5.7Z"
    />
    {/* Inner Plus Symbol */}
    <path
      className="cls-1"
      style={{ stroke: strokeColor }}
      d="M14.92 10v4.92m0 0v4.92m0-4.92h4.92m-4.92 0h-4.92"
    />
  </svg>
);

export const ArrowUpDownIcon = ({
  width = 29.85, // Default width
  height = 29.85, // Default height
  style = {},
  strokeColor = "#433034", // Default stroke color
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.85 29.85"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }`}
      </style>
    </defs>
    {/* Up Arrow */}
    <path
      className="cls-1"
      style={{ stroke: strokeColor, fill: strokeColor }}
      d="M14.92 5l-5 5h3v10h4V10h3l-5-5z"
    />
    {/* Down Arrow */}
    <path
      className="cls-1"
      style={{ stroke: strokeColor, fill: strokeColor }}
      d="M14.92 24.85l5-5h-3V9.85h-4v10h-3l5 5z"
    />
  </svg>
);

export const ArrowUpDown = ({
  width = 110, // Default width
  height = 122, // Default height
  style = {},
  fillColor = "black", // Default fill color
  strokeColor = "black", // Default stroke color
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 110 122"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: ${fillColor};
          stroke: ${strokeColor};
        }`}
      </style>
    </defs>
    <path
      className="cls-1"
      style={{ stroke: strokeColor, fill: strokeColor }}
      d="M31.2177 120.775C30.8212 121.173 30.1752 121.166 29.7871 120.76L1.1442 90.8174C0.324311 89.9603 1.41395 88.6423 2.4099 89.2865L25.4272 104.173C26.0926 104.604 26.9703 104.126 26.9703 103.334V1.5C26.9703 0.947715 27.418 0.5 27.9703 0.5H33.0192C33.5715 0.5 34.0192 0.947716 34.0192 1.5V103.379C34.0192 104.162 34.8783 104.641 35.5446 104.23L59.9954 89.1345C61.0047 88.5114 62.0664 89.8519 61.2287 90.6916L31.2177 120.775Z"
    />
    <path
      className="cls-1"
      style={{ stroke: strokeColor, fill: strokeColor }}
      d="M79.0335 0.786681C79.4293 0.388519 80.0753 0.394183 80.4641 0.799223L109.159 30.6927C109.98 31.5484 108.893 32.8682 107.895 32.2258L84.8526 17.3787C84.1865 16.9495 83.3096 17.4286 83.311 18.221L83.4864 120.054C83.4873 120.607 83.0404 121.055 82.4881 121.056L77.4392 121.065C76.8869 121.066 76.4384 120.619 76.4374 120.067L76.2619 18.1881C76.2606 17.4051 75.4007 16.9273 74.7352 17.3398L50.3103 32.477C49.3022 33.1018 48.2382 31.7631 49.0744 30.922L79.0335 0.786681Z"
    />
  </svg>
);

/* The booking extras, drawn to the same recipe as the icons above: no fill, a
   1.5px round-capped stroke and a 30x30 box, so they sit beside the header set
   without looking borrowed from somewhere else. strokeColor defaults to
   currentColor so a bubble can just set its text colour. */
export const WheelchairSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "currentColor",
  strokeWidth = 1.5,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={width}
    height={height}
    style={style}
  >
    <g
      style={{
        fill: "none",
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    >
      <circle cx="11" cy="4.6" r="2.6" />
      <path d="M9.7 9.4 L9.7 15.2 L16.6 15.2 L20.2 20.6 L23.2 20.6" />
      <path d="M9.7 11.6 L14.6 11.6" />
      <circle cx="12.6" cy="19.4" r="6.8" />
      <circle cx="12.6" cy="19.4" r="2.3" />
    </g>
  </svg>
);

export const StrollerSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "currentColor",
  strokeWidth = 1.5,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={width}
    height={height}
    style={style}
  >
    <g
      style={{
        fill: "none",
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    >
      <path d="M7.6 11.4 L4.9 5.2 L2.9 5.2" />
      <path d="M7.6 11.4 L23.4 11.4 A7.9 7.9 0 0 1 15.5 19.3 A7.9 7.9 0 0 1 7.6 11.4 Z" />
      <path d="M15.5 11.4 L15.5 3.9 A7.5 7.5 0 0 1 23 11.4" />
      <path d="M11.4 19 L10.2 22.2" />
      <path d="M19.6 19 L20.8 22.2" />
      <circle cx="9.6" cy="24.2" r="2.1" />
      <circle cx="21.4" cy="24.2" r="2.1" />
    </g>
  </svg>
);

export const PawSvgIcon = ({
  width = 29.85,
  height = 29.85,
  style = {},
  strokeColor = "currentColor",
  strokeWidth = 1.5,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={width}
    height={height}
    style={style}
  >
    <g
      style={{
        fill: "none",
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    >
      <ellipse cx="9.4" cy="10.2" rx="2.5" ry="3.1" />
      <ellipse cx="15" cy="7.9" rx="2.5" ry="3.1" />
      <ellipse cx="20.6" cy="10.2" rx="2.5" ry="3.1" />
      <ellipse cx="24.4" cy="15.6" rx="2.2" ry="2.7" />
      <ellipse cx="5.6" cy="15.6" rx="2.2" ry="2.7" />
      <path d="M15 15.6 C11.1 15.6 8.2 18.2 8.2 21.3 C8.2 23.7 10 25.4 12.5 25.4 L17.5 25.4 C20 25.4 21.8 23.7 21.8 21.3 C21.8 18.2 18.9 15.6 15 15.6 Z" />
    </g>
  </svg>
);

export const BabyChair = ({
  width = 32,
  height = 32,
  style = {},
  fillColor = "black",
  strokeColor = "black",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 333.000000 318.000000"
    width={width}
    height={height}
    style={style}
  >
    <defs>
      <style>
        {`.cls-1 {
          fill: ${fillColor};
          stroke: ${strokeColor};
        }`}
      </style>
    </defs>
    <g
      className="cls-1"
      transform="translate(-090.000000,390.000000) scale(0.140000,-0.140000)"
    >
      <path
        style={{ stroke: strokeColor, fill: strokeColor }}
        d="M1344 2676 c-68 -31 -124 -83 -153 -140 -15 -32 -35 -118 -62 -278
      -21 -128 -39 -234 -39 -235 0 -2 243 -3 540 -3 297 0 540 1 540 3 0 2 -18 108
      -40 236 -26 158 -46 247 -62 277 -28 57 -84 109 -152 140 -49 23 -59 24 -286
      24 -227 0 -237 -1 -286 -24z"
      />
      <path
        style={{ stroke: strokeColor, fill: strokeColor }}
        d="M860 1765 l0 -85 85 0 c61 0 85 -3 85 -12 0 -7 -38 -237 -84 -510
      l-83 -498 86 0 86 0 79 478 c44 262 82 488 86 501 4 15 17 -42 37 -159 35
      -207 53 -245 132 -287 42 -22 53 -23 261 -23 208 0 219 1 261 23 79 42 97 80
      132 287 20 117 33 174 37 159 4 -13 42 -239 86 -501 l79 -478 86 0 86 0 -83
      498 c-46 273 -84 503 -84 510 0 9 24 12 85 12 l85 0 0 85 0 85 -770 0 -770 0
      0 -85z"
      />
    </g>
  </svg>
);

// A bar chart for Estatísticas, drawn to sit with the menu's other line icons:
// same stroke weight, same strokeColor prop.
export const ChartSvgIcon = ({
  width = 24,
  height = 24,
  style = {},
  strokeColor = "#433034",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={style}
    preserveAspectRatio="xMidYMid meet"
  >
    <path d="M3.5 3.5v16a1 1 0 0 0 1 1h16" fill="none" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.5 16.5v-4M13 16.5v-8M17.5 16.5v-6" fill="none" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
